/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
// import moment from 'moment'
import { format, parse } from 'date-fns'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Button from 'components/Button'
import Dialog from 'components/Dialog'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./UploadList.scss'),
  { columns: require('../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class TemplateUploadList extends Component {
  static propTypes = {
    deleteTemplate: PropTypes.func,
    header: PropTypes.string,
    templateUpload: PropTypes.object.isRequired,
    templateUploadItems: PropTypes.instanceOf(Array),
  }
  static defaultProps = {
    templateUploadItems: {},
    header: '',
    deleteTemplate: null,
  }
  constructor(props) {
    super(props)
    this.state = {
      confirmDeleteDialogOpen: false,
      submit: false,
      documentSelected: '',
    }
  }

  _openConfirmDeleteDialog = (itemId) => {
    this.setState({ confirmDeleteDialogOpen: true })
    this.setState({ documentSelected: itemId })
  }

  _closeConfirmDeleteDialog = () => {
    this.setState({ confirmDeleteDialogOpen: false })
  }

  _saveConfirmDeleteDialog = () => {
    this.setState({
      confirmDeleteDialogOpen: false,
      submit: true,
    })
    this.props.deleteTemplate(this.state.documentSelected)
  }

  renderCols = () => {
    return (
      <tr>
        <th className={(styles.columns.description, headerStyles)}>
          Name
        </th>
        <th className={(styles.columns.status, headerStyles)}>Status</th>
        <th className={(styles.columns.created, headerStyles)}>Created</th>
        <th className={(styles.columns.view, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return this.props.templateUploadItems.length ? (
      this.props.templateUploadItems.sort((a, b) => ((a.itemId < b.itemId) ? 1 : -1)).map(template => (
        <tr className={styles.base} key={template.itemId}>
          <td className={styles.columns.description}>
            <a href={template.path} rel="noopener noreferrer" target="_blank" title={template.documentName}>{template.documentName}</a>
          </td>
          <td>{template.status}</td>
          <td>{(template.created ? format(parse(template.created, constants.DATE_FORMAT.SPO_FORMAT, new Date()), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH_TIME) : '')}</td>
          <td>{template.status === constants.TEMPLATE.UPLOAD.PENDING &&
            <Button
              onClick={() => {
                this._openConfirmDeleteDialog(template.itemId)
              }}
              type="flat"
            >
              DELETE
            </Button>}
            {(template.status === constants.TEMPLATE.UPLOAD.COMPLETED || template.status === constants.TEMPLATE.UPLOAD.COMPLETEDWITHERRORS) &&
            <a href={template.logPath} rel="noopener noreferrer" target="_blank">LOGS</a>}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noPartnerPlans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    const confirmDeleteProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmDeleteDialog },
        { label: 'DELETE', onClick: this._saveConfirmDeleteDialog },
      ],
      title: 'Are you sure you want to delete this document?',
      active: this.state.confirmDeleteDialogOpen,
      onClose: this._closeConfirmDeleteDialog,
    }
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
        <Dialog {...confirmDeleteProps}>
          You will be not able to bring this back once deleted.
        </Dialog>
      </div>
    )
  }
}

export default TemplateUploadList



// WEBPACK FOOTER //
// ./src/views/TemplateUpload/components/TemplateUploadList.js